import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import ContentSection from "../components/EmployerFindYou/ContentSection";
import ButtonSection from "../components/EmployerFindYou/ButtonSection";
import UploadResume from "./UploadResume";
import "./EmployerFindYou.css";

const EmployerFindYou = () => {
  const [showModal, setShowModal] = useState(false);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  return (
    <div className="employers-cv-area pt-5 pb-5">
      <div className="container">
        <div className="employers-cv-bg">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <ContentSection />
            </div>

            <div className="col-lg-4">
              <ButtonSection onClick={handleShowModal} />
            </div>
          </div>
        </div>
      </div>
      {/* Modal for UploadResume */}
      <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Upload Resume</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UploadResume onSuccess={handleCloseModal} />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default EmployerFindYou;
